import * as engagementGroupTypes from './engagementGroupTypes';
import { FORM_MODE } from '../../../../constants/constants';

const initialState = {
  engagementGroupDetailRecordMode: FORM_MODE.CLOSE,
  engagementGroupId: null,
  engagementGroups: [],
  isLoading: false,
  error: null,
  success: false,
  engagementGroupDetails: null,
  allowSpecialChars: '',
  engagementListByGroupId: {}
};

const EngagementsGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Engagement Groups table data
    case engagementGroupTypes.GET_ENGAGEMENT_GROUPS_PENDING:
      return {
        ...state,
        // isLoading: true,
        error: null,
      };
    case engagementGroupTypes.GET_ENGAGEMENT_GROUPS_SUCCESS: {
      return { 
        ...state, 
        engagementGroups: action.engagementGroup,
        // isLoading: false,
        error: null,
        success: true,
      };
    }
    case engagementGroupTypes.GET_ENGAGEMENT_GROUPS_FAILURE:
      return {
        ...state,
        // isLoading: false,
        error: action.error,
        success: false,
      };

    // Get Engagement Group Details based on GroupId
    case engagementGroupTypes.GET_ENGAGEMENT_GROUP_DETAILS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case engagementGroupTypes.GET_ENGAGEMENT_GROUP_DETAILS_SUCCESS: {
      const { messages, allowSpecialChars, allowValidationSpecialChars } = action.engagementGroupDetails;
      let additionalRestriction= ["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"]; 
      additionalRestriction.filter((item,index)=> {let findList=allowSpecialChars.indexOf(item)
        if(findList>-1){
          additionalRestriction.splice(index,1);
        }
      });
      return { 
        ...state,
        engagementGroupDetails: messages,
        allowSpecialChars,
        allowValidationSpecialChars,
        additionalCharRestriction: additionalRestriction,
        isLoading: false,
        error: null,
        success: true,
     };
    }
    case engagementGroupTypes.GET_ENGAGEMENT_GROUP_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        success: false,
      };

    // Save Engagement Group Details based on GroupId
    case engagementGroupTypes.SAVE_ENGAGEMENT_GROUP_DETAILS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case engagementGroupTypes.SAVE_ENGAGEMENT_GROUP_DETAILS_SUCCESS: {
      return {
        ...state,
        engagementGroupDetails: action.response,
        isLoading: false,
        error: null,
        success: true,
      };
    }
    case engagementGroupTypes.SAVE_ENGAGEMENT_GROUP_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        success: false,
      };
    
    // Remove Engagement from the group detail of engagement list by Group ID
    case engagementGroupTypes.DELETE_ENGAGEMENT_BY_GROUP_PENDING: {
      return { ...state, isLoading: true, error: null };
    }
    case engagementGroupTypes.DELETE_ENGAGEMENT_BY_GROUP_SUCCESS: {
      return { ...state, 
        deleteEngagementSuccess: action.deleteEngagementSuccess,
        isLoading: false,
        error: null,
        success: true,
      };
    }
    case engagementGroupTypes.DELETE_ENGAGEMENT_BY_GROUP_FAILURE: {
      return { ...state, 
        isLoading: false,
        error: action.error,
        success: false, 
      };
    }

    // Save Engagement to the group detail of engagement list by Group ID
    case engagementGroupTypes.SAVE_ENGAGEMENT_BY_GROUP_ID_PENDING: {
      return { ...state, isLoading: true, error: null };
    }
    case engagementGroupTypes.SAVE_ENGAGEMENT_BY_GROUP_ID_SUCCESS: {
      return { ...state, 
        isLoading: false,
        error: null,
        success: true,
      };
    }
    case engagementGroupTypes.SAVE_ENGAGEMENT_BY_GROUP_ID_FAILURE: {
      return { ...state, 
        isLoading: false,
        error: action.error,
        success: false, 
      };
    }

    // Set Engagement Group Detail Record Mode
    case engagementGroupTypes.SET_ENGAGEMENT_GROUP_DETAIL_RECORD_MODE: {
      return { ...state, engagementGroupDetailRecordMode: action.mode.mode, engagementGroupId: action.mode.engagementGroupId };
    }

    // Set Engagement List Table of the detail By Group ID Payload
    case engagementGroupTypes.SET_ENGAGEMENT_LIST_BY_GROUP_ID_PAYLOAD: {
      return { ...state, optEngListByGroupIdPayload: action.data };
    }

    // Get Engagement List Table of the detail By Group ID
    case engagementGroupTypes.GET_ENGAGEMENT_LIST_BY_GROUP_ID_SUCCESS: {
      return { ...state,
        engagementListByGroupId: action.engagementListByGroupId,
        isLoading: false,
        error: null,
        success: true,
      };
    }
    case engagementGroupTypes.GET_ENGAGEMENT_LIST_BY_GROUP_ID_FAILURE: {
      return { ...state, 
        isLoading: false,
        error: action.error,
        success: false,
      };
    }

    // Get Engagement List for Adding Engagement Group using Drawer dialog search
    case engagementGroupTypes.GET_ENGAGEMENT_LIST_FOR_ADDING_ENGAGEMENT_GROUP_SUCCESS: {
      return { ...state, engagementOptions: action.engagementOptions };
    }

    // Reset Engagement Group Details
    case engagementGroupTypes.RESET_ENGAGEMENT_GROUP_DETAILS: {
      return { ...state, engagementGroupDetails: {}, engagementListByGroupId: {} };
    }

    default:
      return state;
  }
};

export { initialState };
export default EngagementsGroupReducer;
